import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

const DeleteConfirmationModal = ({ isOpen, toggle, onConfirm }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Confirm Deletion</ModalHeader>
            <ModalBody>
                Are you sure you want to delete this Class <strong>permanently</strong>?
                This action cannot be undone.
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="danger" onClick={onConfirm}>Yes, Delete</Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteConfirmationModal;
